export default __webpack_public_path__ + "static/pattern_02-a6b8d28b054a4548155112191618145a.png";